<template>
  <div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item
        label="Original / Ngày nghỉ phép năm ban đầu"
        prop="original"
      >
        <a-input-number
          v-model="form.original"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
        />
      </a-form-model-item>
      <a-form-model-item
        label="Total annual leave / Tổng ngày phép năm"
        prop="total"
      >
        <a-input-number
          v-model="form.total"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          @change="
            () => {
              form.unused = form.total - form.used;
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item
        label="Total working hour in day / Tổng giờ ca làm việc"
        prop="totalWorkingHoursPerDay"
      >
        <a-input-number
          v-model="form.totalWorkingHoursPerDay"
          placeholder="Enter number..."
          style="width: 100%;"
          :min="1"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
        />
      </a-form-model-item>
      <a-form-model-item
        label="Used / Tổng ngày phép năm đã sử dụng"
        prop="used"
      >
        <a-input-number
          v-model="form.used"
          placeholder="Enter number..."
          style="width: 100%;"
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          @change="
            () => {
              form.unused = form.total - form.used;
            }
          "
        />
      </a-form-model-item>
      <a-form-model-item
        :label="'Unused / Tổng ngày phép năm chưa sử dụng: ' + form.unused"
        prop="unused"
      >
      </a-form-model-item>
    </a-form-model>
    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-popconfirm
        title="confirm action?"
        ok-text="Delete"
        cancel-text="Cancel"
        @confirm="onDelete"
      >
        <a-button
          icon="delete"
          type="danger"
          style="float: left;"
          :loading="loadingBtn"
        >
          Delete
        </a-button>
      </a-popconfirm>
      <a-button @click="close" style="margin-right: 5px;">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
        Update
      </a-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import queryAnnualLeaveYear from "../../Constants/queryAnnualLeaveYear";

const rules = {
  original: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  totalWorkingHoursPerDay: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  total: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  unused: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
  used: [
    {
      required: true,
      message: "Thông tin bắt buộc nhập",
      trigger: "change",
    },
  ],
};

export default {
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    refreshAfterDeleted: {
      type: Function,
      default: () => {},
    },
    refreshAfterUpdated: {
      type: Function,
      default: () => {},
    },
    annualLeaveYear: {
      type: Object,
      required: true,
    },
    employee: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      now: moment(),
      form: {},
      loadingBtn: false,
    };
  },
  created() {
    this.form = {
      ...this.annualLeaveYear,
      total:
        this.annualLeaveYear.total /
        +this.annualLeaveYear.totalWorkingHoursPerDay,
      used:
        this.annualLeaveYear.used /
        +this.annualLeaveYear.totalWorkingHoursPerDay,
      unused:
        this.annualLeaveYear.unused /
        +this.annualLeaveYear.totalWorkingHoursPerDay,
      original:
        this.annualLeaveYear.original /
        +this.annualLeaveYear.totalWorkingHoursPerDay,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdateEmployeeAnnualLeaveYear();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onUpdateEmployeeAnnualLeaveYear() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: queryAnnualLeaveYear.updateEmployeeAnnualLeaveYear,
          variables: {
            ...this.form,
            total: +this.form.total * +this.form.totalWorkingHoursPerDay,
            unused: +this.form.unused * +this.form.totalWorkingHoursPerDay,
            used: +this.form.used * +this.form.totalWorkingHoursPerDay,
            original: +this.form.original * +this.form.totalWorkingHoursPerDay,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployeeAnnualLeaveYear) {
            this.refreshAfterUpdated(data.updateEmployeeAnnualLeaveYear);
          }
          this.close();
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.error("Lỗi thêm mới", err);
        });
    },
    onDelete() {
      if (!this.form.id) {
        throw new Error("cannot get id");
      }
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: queryAnnualLeaveYear.deleteEmployeeAnnualLeaveYear,
          variables: {
            id: this.form.id,
          },
        })
        .then(({ data }) => {
          if (data?.deleteEmployeeAnnualLeaveYear) {
            this.refreshAfterDeleted(data.deleteEmployeeAnnualLeaveYear);
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Deleted Success!",
          });
          this.close();
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Xóa thông tin lỗi!", error);
        });
    },
  },
};
</script>
